import styled from 'styled-components'

export const ContainerConfig = styled.div`
  width: 25%;
  box-sizing: border-box;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  background-color: white;
  position: absolute;
  z-index: 2;
  left: 10px;
  top: 10px;
  border-radius: 10px;
`

export const PopupRemover = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  font-weight: 600;
  font-size: 12px;
`

export const PainelPropsGrid = styled.div`
  position: absolute;
  top: 5px;
  left: 5px;
  width: 300px;
  background: #fff;
  z-index: 9999;
  box-sizing: border-box;
  padding: 20px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  opacity: 0;
  transform: translateY(50px);
  animation: fade 1s forwards;
  animation-timing-function: cubic-bezier(0.075, 0.82, 0.165, 1);
  will-change: transform;
  overflow: hidden;
  transition: 0.2s;

  :is([data-shrink='true']) {
    transition: 0.5s;
    width: 200px;
    height: 70px;
  }

  @keyframes fade {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0px);
    }
  }

  div.PainelProps__info {
    display: flex;
    gap: 20px;
  }
`

export const ModalBaixar = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`
